module.exports = __webpack_public_path__ + "static/media/dona-mariquinha.bbb77727.jpeg";